<div class="prompts-modal">
  <div class="pg-header">
    <h4 class="modal-title">Prompts Gallery</h4>
    <button type="button" class="close-btn" (click)="activeModal.dismiss()" aria-label="Close">&times;</button>
  </div>

  <div class="toolbar-row">
    <div class="tabs">
      <button class="tab" [ngClass]="{ active: selectedTab === 'system' }" (click)="selectTab('system')">System Prompts</button>
      <button class="tab" [ngClass]="{ active: selectedTab === 'my' }" (click)="selectTab('my')">My Prompts</button>
    </div>
    <button class="add-btn" (click)="openAddNew()">+ Add New</button>
  </div>

  <div class="pg-body">
    <div class="filters-row">
      <input class="search-input" placeholder="Search" [(ngModel)]="searchTerm" />
      <div class="category-dropdown" [class.open]="isCategoryDropdownOpen">
        <button class="category-select" type="button" (click)="toggleCategoryDropdown()">
          <span>{{ categoryDisplayText }}</span>
          <span class="category-caret">▾</span>
        </button>
        <div class="category-menu" *ngIf="isCategoryDropdownOpen">
          <button type="button" class="category-clear-btn" (click)="clearCategorySelection(); onCategoryChange()">
            Clear selection
          </button>
          <label class="category-option" *ngFor="let category of selectableCategories">
            <input
              type="checkbox"
              [checked]="isCategorySelected(category)"
              (change)="onToggleCategory(category, $any($event.target).checked); onCategoryChange()"
            />
            <span>{{ category }}</span>
          </label>
        </div>
      </div>
    </div>

    <div *ngIf="isLoading" class="loading">Loading prompts...</div>
    <div *ngIf="!isLoading && filteredPrompts.length === 0" class="empty">No prompts available.</div>

    <div class="prompts-scroll" *ngIf="!isLoading && filteredPrompts.length > 0">
      <div class="prompts-grid">
        <div
          class="prompt-card"
          *ngFor="let p of filteredPrompts"
          (click)="selectPrompt(p)"
          (keydown.enter)="selectPrompt(p)"
          (keydown.space)="selectPrompt(p); $event.preventDefault()"
          tabindex="0"
          role="button"
          [attr.aria-label]="'Use prompt: ' + p.text"
        >
          <span class="prompt-text">{{ p.text }}</span>
          <div class="prompt-actions" *ngIf="isUserPrompt(p)">
            <button
              class="prompt-action-btn"
              type="button"
              title="Edit prompt"
              aria-label="Edit prompt"
              (click)="openEdit(p); $event.stopPropagation()"
            >
              <img src="assets/icons/edit-icon.svg" alt="Edit" />
            </button>
            <button
              class="prompt-action-btn"
              type="button"
              title="Delete prompt"
              aria-label="Delete prompt"
              (click)="deletePrompt(p); $event.stopPropagation()"
            >
              <img src="assets/icons/bin-icon.svg" alt="Delete" />
            </button>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="isEditing" class="edit-modal-backdrop">
      <div class="edit-modal">
        <div class="edit-header">
          <h5>{{ editingPrompt ? 'Edit Prompt' : 'Add New Prompt' }}</h5>
          <button class="icon-btn" (click)="cancelEdit()">&times;</button>
        </div>
        <div class="edit-body">
          <p class="edit-subtitle" *ngIf="!editingPrompt">
            Enter your prompt message below. This will be saved to your personal prompts collection.
          </p>

          <label class="label">Prompt Category</label>
          <select class="form-input" [ngModel]="selectedPromptCategory" (ngModelChange)="onPromptCategoryChange($event)">
            <option value="" disabled>Select Prompt Category</option>
            <option *ngFor="let category of formCategories" [value]="category">{{ category }}</option>
            <option *ngIf="isAddMode" value="__add_new__">+ Add New Category</option>
          </select>
          <input
            *ngIf="isAddMode && isAddingNewPromptCategory"
            type="text"
            class="form-input new-category-input"
            [(ngModel)]="newPromptCategoryName"
            placeholder="Enter new category"
          />

          <label class="label">Prompt Message</label>
          <textarea class="form-input" [(ngModel)]="newPromptText" rows="6" placeholder="Enter your prompt message..."></textarea>
        </div>
        <div class="edit-footer">
          <button class="btn btn-secondary" (click)="cancelEdit()">Cancel</button>
          <button class="btn btn-primary" (click)="savePrompt()" [disabled]="!canSavePrompt">Save</button>
        </div>
      </div>
    </div>
  </div>
</div>
